import './breadcrumb.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import LocalizedLink from './LocalizedLink';

interface IBreadcrumbElements {
    name: string;
    link: string;
}

interface IBreadcrumbProps {
    elements: IBreadcrumbElements[];
    className?: string;
}

export default function Breadcrumb(props: IBreadcrumbProps) {
    const size = props.elements.length;
    const separator = <FontAwesomeIcon icon={faChevronRight} />;
    const { className = '' } = props;

    const isLastElement = (index: number) => {
        return index + 1 === size;
    };

    const currentpath = () => {
        if (typeof window !== 'undefined') {
            const fullPathArray = window.location.pathname.split('/');
            fullPathArray.shift();
            fullPathArray.shift();
            fullPathArray.shift();
            return fullPathArray.join('/');
        }
    };

    return (
        <div className={`breadcrumb ${className}`}>
            {props.elements.map(
                (element: IBreadcrumbElements, index: number) => {
                    return (
                        <React.Fragment key={index}>
                            {isLastElement(index) ? (
                                <span className='breadcrumb-link last'>
                                    <LocalizedLink
                                        to={
                                            element?.link && element.link.trim() !== ''
                                                ? element.link
                                                : currentpath() ?? null
                                        }
                                    >
                                        {element.name}
                                    </LocalizedLink>
                                </span>
                            ) : (
                                <span className='breadcrumb-link'>
                                    <LocalizedLink to={element.link}>
                                        {element.name}
                                    </LocalizedLink>
                                </span>
                            )}

                            {!isLastElement(index) && (
                                <span className='breadcrumb-separator'>
                                    {separator}
                                </span>
                            )}
                        </React.Fragment>
                    );
                }
            )}
        </div>
    );
}
